import { Button } from "../design-system/Button";
import React, { useEffect, useState } from "react";
import { useMenuPost } from "./client";
import { useAlert } from "react-alert";

import { Status } from "../client/status";
import { Box, Paper, TextField, Typography } from "@mui/material";

export const CreateMenu = () => {
  const [restaurantName, setRestaurantName] = useState("");
  const { status, setMenu, menuId } = useMenuPost();
  const alert = useAlert();

  useEffect(() => {
    if (status === Status.Success) {
      window.open(`/dashboard/menu/${menuId}/update`, "_self");
    }
    if (status === Status.Error) {
      alert.error("Request Failed");
    }
  }, [status, alert, menuId]);

  const submitMenu = () => {
    restaurantName || alert.error("Please enter restaurant name.");
    restaurantName &&
      setMenu({
        restaurantName,
      });
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="calc(100vh - 60px)"
      px={2}
    >
      <Paper
        elevation={4}
        sx={{ maxWidth: 480, width: "100%", borderRadius: 3, p: 5 }}
      >
        <Typography variant="h5" fontWeight={700} align="center" gutterBottom>
          Name your restaurant
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ mb: 4 }}
        >
          This is the first step. You'll add your menu items, set up ordering,
          and get a QR code next.
        </Typography>

        <TextField
          fullWidth
          variant="outlined"
          label="Restaurant name"
          placeholder="e.g. The Cozy Cafe"
          onChange={(event) => setRestaurantName(event.target.value)}
          onKeyPress={(event) => event.key === "Enter" && submitMenu()}
          sx={{ mb: 2 }}
        />
        <Button variant="contained" fullWidth size="large" onClick={submitMenu}>
          Create menu
        </Button>
      </Paper>
    </Box>
  );
};
